import React, { useContext, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { ConfigContext } from '../../Context/ConfigContext';

const HeaderTop = () => {
    const location = useLocation();
    const { currency, setCurrency, setCurrencyValue } = useContext(ConfigContext)


    useEffect(() => {
        const scriptUrls = [
            "https://stoneskill.com/assets/js/main.js?v=5.3",
            "https://stoneskill.com/assets/js/shop.js?v=5.3"
        ];

        const addedScripts = [];

        const timeoutId = setTimeout(() => {
            scriptUrls.forEach(url => {
                if (!document.querySelector(`script[src="${url}"]`)) {
                    const script = document.createElement("script");
                    script.src = url;
                    script.async = true;
                    script.onload = () => console.log(`${url} loaded successfully`);
                    document.body.appendChild(script);
                    addedScripts.push(script);
                }
            });
        }, 1000);

        return () => {
            clearTimeout(timeoutId);
            addedScripts.forEach(script => {
                if (document.body.contains(script)) {
                    document.body.removeChild(script);
                }
            });
        };
    }, [location.pathname]);

    const handleChangeCurrency = (selectedCurrency) => {
        if (selectedCurrency === 'INR') {
            setCurrencyValue('INR')
            setCurrency('₹')
            localStorage.setItem('currency_label', '₹')
            localStorage.setItem('currency_value', 'INR')
            window.location.reload()
        } else {
            setCurrencyValue('USD')
            setCurrency('$');
            localStorage.setItem('currency_label', '$')
            localStorage.setItem('currency_value', 'USD')
            window.location.reload()
        }
    }
    return (
        <>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-xl-3 col-lg-4">
                        <div className="header-info">
                            <ul>
                                <li>
                                    <Link to={'/MyAccount'}>MyAccount</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-xl-6 col-lg-4">
                        <div className="text-center">
                            <div id="news-flash" className="d-inline-block">
                                <ul style={{ color: "#9E423E" }}>
                                    <li>A solid, natural mineral or rock with varied textures and colors.</li>
                                    <li>A hard, durable substance formed by geology.</li>
                                    <li>A timeless material used for construction, art, and decoration.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-4">
                        <div className="header-info header-info-right">
                            <ul>
                                <li>
                                    <a>
                                        <img src={currency === "₹" ? "https://flagcdn.com/w40/in.png" : "https://flagcdn.com/w40/us.png"} width={"20%"} alt /> {currency === "₹" ? "INR" : "USD"} <i className="fi-rs-angle-small-down" />
                                    </a>
                                    <ul className="language-dropdown">
                                        <li>
                                            <a onClick={() => handleChangeCurrency("INR")}><img src="https://flagcdn.com/w40/in.png" alt />INR</a>
                                        </li>
                                        <li>
                                            <a onClick={() => handleChangeCurrency("USD")}><img src="https://flagcdn.com/w40/us.png" alt />USD</a>
                                        </li>
                                    </ul>
                                </li>
                                <li><Link to="/WishList">Wishlist</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default HeaderTop